var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "premixes-container mt-3 py-3 pl-3 pr-0" }, [
    _c("h4", { staticClass: "pl-4 text-capitalize" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["virtualtray.premixes.modal.header"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-flex pl-3 pb-4 results-wrapper flex-wrap justify-content-between"
      },
      _vm._l(
        _vm.premixes.sort(function(a, b) {
          return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        }),
        function(premix, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "col-12 col-md-6 result-wrapper pr-3",
              on: {
                click: function($event) {
                  return _vm.$emit("onPremixClick", premix)
                }
              }
            },
            [
              _c("div", { staticClass: "img-wrapper" }, [
                _c("div", {
                  staticClass: "result-img",
                  style: [
                    { backgroundImage: "url('" + premix.imagePath + "')" }
                  ],
                  attrs: { slot: "item", item: premix },
                  slot: "item"
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(_vm._s(premix.name))
              ])
            ]
          )
        }
      ),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }